module.exports = __webpack_public_path__ + "img/frame (142).0327ae60.jpg";